"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Popover = void 0;
const tslib_1 = require("tslib");
const rc_tooltip_1 = tslib_1.__importDefault(require("rc-tooltip"));
const react_1 = tslib_1.__importDefault(require("react"));
const placements_1 = require("./placements");
const Popover_styles_1 = require("./Popover.styles");
const Popover = (_a) => {
    var { paperProps, overlay, getTooltipContainer, minWidth, maxWidth, 'data-test-specifier': dataTestSpecifier = '' } = _a, rest = tslib_1.__rest(_a, ["paperProps", "overlay", "getTooltipContainer", "minWidth", "maxWidth", 'data-test-specifier']);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(Popover_styles_1.Global, { id: "global-popover-styles" }),
        react_1.default.createElement(rc_tooltip_1.default, Object.assign({}, rest, { builtinPlacements: placements_1.builtinPlacements, prefixCls: "cld-popover", getTooltipContainer: getTooltipContainer, overlay: react_1.default.createElement(Popover_styles_1.StyledPaper, Object.assign({ isPadded: true, maxWidth: maxWidth, minWidth: minWidth, borderRadius: "md" }, paperProps, { "data-test-specifier": `popover${dataTestSpecifier ? '-' + dataTestSpecifier : ''}` }), overlay) }))));
};
exports.Popover = Popover;
exports.Popover.defaultProps = {
    animation: 'zoom',
};
//# sourceMappingURL=Popover.js.map